import React from 'react'


function Banner() {
  return (
    <div className='banner'>
        <img src= {require('./images/banner.jpg')} alt="Rafting Mustafa Banner"></img>
       
    </div>
  )
}

export default Banner